import { render } from "./BulkCreator.vue?vue&type=template&id=53ec889a"
import script from "./BulkCreator.vue?vue&type=script&lang=js"
export * from "./BulkCreator.vue?vue&type=script&lang=js"

import "./BulkCreator.vue?vue&type=style&index=0&id=53ec889a&lang=scss"

import exportComponent from "/home/forge/api-staging.champagne-booking.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__